export const SavePatientsForVisit = (destinationLang) => {
  return [
    {
      FormKey: 'save-patients-for-visit-navbar-title',
      Key: 'ثبت بیمار',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-national-code',
      Key: 'کدملی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-marriage-state',
      Key: 'وضعیت تاهل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-birth-date',
      Key: 'تاریخ تولد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-blood-group',
      Key: 'گروه خونی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-job-list',
      Key: 'شغل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-education-list',
      Key: 'تحصیلات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-how-meet',
      Key: 'نحوه ی آشنایی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-religion-list',
      Key: 'مذهب',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'save-patients-for-visit-form-input-zone',
      Key: 'منطقه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-postal-code',
      Key: 'کد پستی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-form-input-country-birth',
      Key: 'کشور محل تولد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-edit-patient-info-btn',
      Key: 'ویرایش اطلاعات بیمار',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'save-patients-for-visit-add-new-patient-btn',
      Key: 'بیمار جدید',
      DistinitationLanguage: destinationLang,
    },
  ];
};
